// packages block
import { FC, useContext } from 'react'
import { useSearchParams } from 'react-router-dom'
// components block
import { PaginationWithJump } from './PaginationWithJump'
// others block
import { AppContext } from '../../context/AppContext'
import { ActionType } from '../../context/AppContextReducer'
import { PaginationProps } from '../../interfaceTypes'

export const CustomPagination: FC<PaginationProps> = ({ loading, setParams }) => {
  const { totalPageCount, currentPage, dispatch } = useContext(AppContext)
  const [searchParams, setSearchParams] = useSearchParams()

  const handleChange = (newPage: number) => {
    dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: newPage })
    setParams && searchParams.set('currentPage', newPage.toString())
    setParams && setSearchParams(searchParams)
  }

  return <PaginationWithJump disabled={loading} count={totalPageCount} page={currentPage} onChange={handleChange} />
}
